import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'
import LiveboardLayout from './LiveboardLayout/LiveboardLayout'

export default function LiveboardRoutes() {
  return (
    <ErrorBoundaryComponent>
      <LiveboardLayout />
    </ErrorBoundaryComponent>
  )
}
